import React, { FC, MouseEvent, useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import { DenominationCategory, DenominationCategoryType } from '@entities/denomination';
import { useCyberStore } from '@entities/tsp';
import { Carousel } from '@shared/ui/organisms';
import { ControlRow } from '@shared/ui/molecules';
interface PickDenominationCategoryProps {
  categories: DenominationCategoryType[];
  onCategoryClick: (category: DenominationCategoryType) => void;
}
const PickDenominationCategory: FC<PickDenominationCategoryProps> = ({
  categories,
  onCategoryClick
}) => {
  const [selectedCategory, setSelectedCategory] = useState<string>(categories[0]?.label ?? '');
  const {
    activeCountry
  } = useCyberStore();
  useEffect(() => {
    setSelectedCategory(categories[0]?.label ?? '');
  }, [activeCountry]);
  const handleCategoryClick = (e: MouseEvent<HTMLElement>, category: DenominationCategoryType) => {
    e.currentTarget.scrollIntoView({
      behavior: 'auto',
      block: 'nearest',
      inline: 'center'
    });
    setSelectedCategory(category.label);
    onCategoryClick(category);
  };
  return <Carousel alwaysShowScrollButtons leftButton={<ControlRow withArrowBg direction="left" />} rightButton={<ControlRow withArrowBg direction="right" />}>
      <PickDenominationCategoryWrapper>
        {categories.map(category => <DenominationCategory key={category.label} isSelected={category.label === selectedCategory} category={category} onClick={handleCategoryClick} />)}
      </PickDenominationCategoryWrapper>
    </Carousel>;
};
export default PickDenominationCategory;
const PickDenominationCategoryWrapper = /*#__PURE__*/styled('ul')({
  name: "PickDenominationCategoryWrapper",
  class: "p12vbfuw",
  propsAsIs: false
});

require("./PickDenominationCategory.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PickDenominationCategory.tsx");